
export default function PremiumReasons() {
  return (
    <section id="premium-reasons" className="py-32 bg-gradient-to-br from-white via-[#F0FDF4] to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#10B981]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#10B981]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2 bg-[#10B981]/10 text-[#10B981] text-sm font-semibold rounded-full mb-6">
            PREMIUM BENEFITS
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            보험료가 낮아지는 이유
          </h2>
          <p>
            케어인슈만의 차별화된 시스템으로 합리적인 보험료를 실현합니다
          </p>
        </div>

        {/* Main Content with Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Content */}
          <div className="space-y-8">
            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#10B981]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-line-chart-line text-3xl text-[#10B981]"></i>
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">20년 자사경험요율 적용</h3>
                  <p>
                    20년간 축적된 장기요양시설 사고 데이터를 기반으로 정확한 위험도를 산정하여 불필요한 보험료 부담을 제거했습니다.
                  </p>
                  <div className="bg-[#10B981]/5 rounded-xl p-4 border border-[#10B981]/20">
                    <p>
                      타사 대비 평균 15-20% 낮은 보험료
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#10B981]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-3xl text-[#10B981]"></i>
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">정확한 사고 구분</h3>
                  <p>
                    작위(전문인 과실), 부작위(시설 과실), 순수(자연발생) 사고를 명확히 구분하여 불필요한 보험금 지급을 방지하여, 보험료를 낮출 수 있습니다.
                  </p>
                  <div className="bg-[#10B981]/5 rounded-xl p-4 border border-[#10B981]/20">
                    <p>
                      부당 청구 방지로 보험료 절감
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#10B981]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-refresh-line text-3xl text-[#10B981]"></i>
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">합리적 할증 체계</h3>
                  <p>
                    사고 발생 시에도 과도한 할증 없이 합리적인 수준에서 재가입이 가능하여 장기적으로 안정적인 보험료를 유지할 수 있습니다.
                  </p>
                  <div className="bg-[#10B981]/5 rounded-xl p-4 border border-[#10B981]/20">
                    <p>
                      사고 후에도 계속 가입 가능
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#10B981]/20 to-transparent rounded-3xl transform -rotate-3 group-hover:rotate-3 transition-transform duration-500"></div>
            <img 
              src="https://public.readdy.ai/ai/img_res/daab705cb1b9d9336c13286414f5df7f.jpg"
              alt="보험료 절감"
              className="relative rounded-3xl shadow-2xl w-full h-[700px] object-cover transform group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 border-2 border-[#10B981]/20">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#10B981]/10 rounded-xl flex items-center justify-center">
                  <i className="ri-price-tag-3-line text-2xl text-[#10B981]"></i>
                </div>
                <div>
                  <p>평균 절감률</p>
                  <p>15-20%</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="bg-gradient-to-br from-white to-[#F0FDF4] rounded-3xl p-6 md:p-12 shadow-xl border-2 border-[#10B981]/20">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 md:mb-12 text-center">케어인슈 vs 일반 보험</h3>
          <div className="overflow-x-auto -mx-6 md:mx-0">
            <div className="inline-block min-w-full align-middle px-6 md:px-0">
              <table className="w-full min-w-[500px]">
                <thead>
                  <tr className="border-b-2 border-[#10B981]/20">
                    <th className="py-4 md:py-6 px-3 md:px-6 text-left text-sm md:text-base font-bold text-gray-900">구분</th>
                    <th className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base font-bold text-[#10B981]">케어인슈</th>
                    <th className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base font-bold text-gray-500">일반 보험</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100 hover:bg-[#F0FDF4]/30 transition-colors">
                    <td className="py-4 md:py-6 px-3 md:px-6 text-sm md:text-base font-semibold text-gray-900">보험료 산정</td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-700">
                      <span className="inline-flex items-center justify-center px-3 py-1 bg-[#10B981]/10 text-[#10B981] rounded-full font-medium text-xs md:text-sm">
                        20년 자사경험요율
                      </span>
                    </td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-500">일반 요율</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-[#F0FDF4]/30 transition-colors">
                    <td className="py-4 md:py-6 px-3 md:px-6 text-sm md:text-base font-semibold text-gray-900">사고 구분</td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-700">
                      <span className="inline-flex items-center justify-center px-3 py-1 bg-[#10B981]/10 text-[#10B981] rounded-full font-medium text-xs md:text-sm">
                        3단계 명확한 구분
                      </span>
                    </td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-500">단순 구분</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-[#F0FDF4]/30 transition-colors">
                    <td className="py-4 md:py-6 px-3 md:px-6 text-sm md:text-base font-semibold text-gray-900">재가입</td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-700">
                      <span className="inline-flex items-center justify-center px-3 py-1 bg-[#10B981]/10 text-[#10B981] rounded-full font-medium text-xs md:text-sm">
                        합리적 할증으로 보장
                      </span>
                    </td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-500">가입 거절 가능</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-[#F0FDF4]/30 transition-colors">
                    <td className="py-4 md:py-6 px-3 md:px-6 text-sm md:text-base font-semibold text-gray-900">손해사정</td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-700">
                      <span className="inline-flex items-center justify-center px-3 py-1 bg-[#10B981]/10 text-[#10B981] rounded-full font-medium text-xs md:text-sm">
                        전담 전문가
                      </span>
                    </td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-500">일반 사정사</td>
                  </tr>
                  <tr className="hover:bg-[#F0FDF4]/30 transition-colors">
                    <td className="py-4 md:py-6 px-3 md:px-6 text-sm md:text-base font-semibold text-gray-900">보험료 수준</td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-700">
                      <span className="inline-flex items-center justify-center px-3 py-1 bg-[#10B981]/10 text-[#10B981] rounded-full font-medium text-xs md:text-sm">
                        15-20% 절감
                      </span>
                    </td>
                    <td className="py-4 md:py-6 px-3 md:px-6 text-center text-sm md:text-base text-gray-500">일반 수준</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
